import Vue from 'vue';

import '@/_plugins/vueDepFix';
import '@/_plugins/composition-api';
import '@/_plugins/signalr';
import '@/_plugins/portal';

import vuetify from '@/_plugins/vuetify';
import router, { initializeMainRouter } from './_router';
import publicIdeaPortalRouter from './_publicIdeaPortalRouter';
import aiStorymapRouter from './_aiStorymapRouter';

import '@/_core/app-components';
import '@/_plugins/timeago';
import '@/_plugins/clipboard';
import '@/_plugins/vue-the-mask';
import '@/_plugins/vue-upload-component';
import '@/_plugins/v-viewer';
import '@/_plugins/keyCodes';
import '@/_plugins/syncfusion';

import App from './App.vue';
import PublicIdeaPortalApp from './PublicIdeaPortalApp.vue';
import AiStorymapApp from './AiStorymapApp.vue';

import '@/_plugins/bugsnag';

const isDev = process.env.NODE_ENV !== 'production';

Vue.config.productionTip = false;
Vue.config.devtools = isDev;
Vue.config.performance = isDev;
if (isDev && typeof performance !== 'undefined' && performance.clearMeasures) {
    // Vue records a measure for every component init, render and patch and never clears them. Firefox's clearMarks walks the
    // whole buffer, so a long session on a large board slowed every mount down until a view switch took a minute.
    // A profile recorded while the measure was made keeps it; only the buffer is emptied.
    setInterval(() => performance.clearMeasures(), 5000);
}
if (!isDev) {
    console.trace = function() {
        return;
    };
}

if (initAppData.isInPublicIdeaPortalContext) {
    new Vue({
        router: publicIdeaPortalRouter,
        vuetify,
        render: (h) => h(PublicIdeaPortalApp),
    }).$mount('#app');
} else if (initAppData.isInAiStorymapContext) {
    new Vue({
        router: aiStorymapRouter,
        vuetify,
        render: (h) => h(AiStorymapApp),
    }).$mount('#app');
} else {
    initializeMainRouter();
    new Vue({
        router,
        vuetify,
        render: (h) => h(App),
    }).$mount('#app');
}
